import { Source } from "./basicModels";

export const sourceModel = Source;
